import { memo } from "react";
import { styled } from "@mui/material";
import Calendar from "@icons-rf/calendar-icon.svg?react";
import MxTypography from "@rf-l1/MxTypography";

interface BuildingHeaderProps {
  nameBuilding: string;
  deliveryDate?: string;
  buildingIndex: number;
}

const BuildingHeader = memo(
  ({ nameBuilding, deliveryDate, buildingIndex }: BuildingHeaderProps) => {
    return (
      <HeaderTable>
        <TitleBuilding>
          {nameBuilding || `Edificio ${buildingIndex + 1}`}
        </TitleBuilding>
        <Spacing />
        {deliveryDate && (
          <ContentDate>
            <MxTypography variant="caption" sx={{ color: "white", fontWeight: 700 }}>
              Fecha de entrega
            </MxTypography>
            <DateBuilding>
              <Calendar
                style={{
                  width: "16px",
                  height: "16px",
                  fill: "var(--m-color-blue-03)"
                }}
              />
              <MxTypography
                variant="caption"
                sx={{ color: "var(--m-color-blue-03)", fontWeight: 700 }}
              >
                {deliveryDate}
              </MxTypography>
            </DateBuilding>
          </ContentDate>
        )}
      </HeaderTable>
    );
  }
);

BuildingHeader.displayName = "BuildingHeader";

export default BuildingHeader;

// Styled Components
const HeaderTable = styled("div")(({ theme }) => ({
  width: "100%",
  display: "flex",
  borderTopLeftRadius: "20px",
  borderTopRightRadius: "20px",
  flexDirection: "row",
  height: "40px",
  backgroundColor: "var(--m-color-blue-03)",
  alignItems: "center"
}));

const TitleBuilding = styled("span")(({ theme }) => ({
  fontFamily: "Inter",
  fontSize: "13px",
  fontWeight: 700,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "left",
  color: "white",
  padding: "0 20px"
}));

const DateBuilding = styled("div")(({ theme }) => ({
  fontFamily: "Inter",
  fontSize: "13px",
  fontWeight: 700,
  lineHeight: "19px",
  letterSpacing: "0em",
  textAlign: "left",
  color: "white",
  backgroundColor: "white",
  borderRadius: "20px",
  padding: "0 10px",
  height: "25px",
  display: "flex",
  justifyContent: "center",
  alignItems: "center"
}));

const ContentDate = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  columnGap: "10px",
  marginRight: "20px"
}));

const Spacing = styled("div")(({ theme }) => ({
  flex: 1
}));
